import "./style.css";

import React from "react";

interface IAudioVolumeSliderProps {
  volume: number;
  onVolumeChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const AudioVolumeSlider: React.FC<IAudioVolumeSliderProps> = ({
  volume,
  onVolumeChange,
}) => (
  <input
    type="range"
    min="0"
    max="100"
    value={volume * 100}
    onChange={onVolumeChange}
    className="audio-volume-slider"
  />
);

export default AudioVolumeSlider;
